class Customer.Notifier extends Backbone.Model
  urlRoot: '/customer/conversations/notifications'

  sendNotifications: (assignedToName, users) =>
    $.ajax
      url: @urlRoot
      type: 'POST'
      data: 'notification': {'conversation_id': @get('model').id, 'assigned_to_name': assignedToName, 'users': users}

  sendGroupNotifications: (usersGroups, assignedToGroupId) =>
    selectedGroup = _.find(usersGroups, (group) => (group.id == assignedToGroupId))
    @sendNotifications(selectedGroup.name, selectedGroup.user_ids)

class Customer.NotifiersCollection extends Backbone.Collection
  model: Customer.Notifier
